import { ComponentWithTooltip } from 'components/ComponentWithTooltip';
import { ButtonWithTooltip } from 'components/WithTooltip';
import type { WorkOrderPriceItem } from 'gql/graphql';
import { ActKc2StatusEnum, ContractStatusEnum, WorkOrderStatusEnum } from 'gql/graphql';
import { cnMixSpace, IconAlert, IconCopy } from 'uikit';

import type { CustomHeaderProps } from 'ag-grid-react';
import { useCallback } from 'react';

import { useCopyActSkzsPlan } from './hooks/useCopyActSkzsPlan';

interface IActSkzsHeaderRenderer extends CustomHeaderProps<WorkOrderPriceItem> {
    actId: number;
    isSKzSUpdated: boolean;
    actStatus: ActKc2StatusEnum;
    workOrderStatus: WorkOrderStatusEnum;
    contractStatus: ContractStatusEnum;
    isDisabledByProjectStatus: boolean;
    onSuccess: () => void;
    isSKzSCopyLock: boolean;
}

export const ActSkzsHeaderRenderer = (props: IActSkzsHeaderRenderer) => {
    const {
        actId,
        workOrderStatus,
        isDisabledByProjectStatus,
        contractStatus,
        actStatus,
        onSuccess,
        isSKzSUpdated,
        isSKzSCopyLock,
    } = props;

    const isDisabledByWorkOrderStatus =
        workOrderStatus === WorkOrderStatusEnum.Completed || workOrderStatus === WorkOrderStatusEnum.Delayed;
    const isDisabledByActStatus = actStatus !== ActKc2StatusEnum.InProgress;

    const isDisabled = Boolean(
        isDisabledByActStatus ||
            isDisabledByProjectStatus ||
            isDisabledByWorkOrderStatus ||
            contractStatus !== ContractStatusEnum.InImplementation ||
            isSKzSCopyLock,
    );

    const { handleCopyAllPlanValues } = useCopyActSkzsPlan({
        onSuccess,
    });

    const handleClick = useCallback(() => {
        handleCopyAllPlanValues(actId);
    }, [actId, handleCopyAllPlanValues]);

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {isSKzSUpdated && actStatus !== ActKc2StatusEnum.Accepted && (
                <ComponentWithTooltip
                    tooltipText="Данные по объему обновлены"
                    className={cnMixSpace({
                        mR: '2xs',
                    })}
                    styles={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <IconAlert size="s" view="warning" />
                </ComponentWithTooltip>
            )}
            {actStatus === ActKc2StatusEnum.InProgress && (
                <ButtonWithTooltip
                    buttonProps={{
                        iconLeft: IconCopy,
                        onlyIcon: true,
                        view: 'clear',
                        size: 's',
                        className: cnMixSpace({
                            mR: '2xs',
                        }),
                        onClick: handleClick,
                        disabled: isDisabled,
                    }}
                    tooltipProps={{
                        content: 'Скопировать все данные из СКзС',
                    }}
                />
            )}
            Объем (План СКзС)
        </div>
    );
};

ActSkzsHeaderRenderer.displayName = 'ActSkzsHeaderRenderer';
